import { PaymentInterval } from '@/shared/types/Billing';

export const getPlanGtmName = (name: string, paymentPeriod: PaymentInterval) => {
  return `${name} ${paymentPeriod === PaymentInterval.Month ? 'Monthly' : 'Annual'}`;
};
